import {
	isEmpty,
	get,
	omit,
} from 'lodash';

import { environment } from '../../../../environments/environment';
import { IBuildConfiguration } from '../../../../config/config.interface';
import { ICommonAppConfig } from '../../app/app.config.token';
import { CommonDataServiceClass } from '../data.service';
import {
	ICommonAppData,
	TLocalAppDataGetter,
} from './local_app_data.token';

export interface ICommonAppDataServiceData extends ICommonAppData, ICommonAppConfig, Omit<IBuildConfiguration, 'proxy' | 'language' | 'devspecs'> {
	readonly isDevServer: boolean;
}

export class CommonAppDataService extends CommonDataServiceClass<ICommonAppDataServiceData> {
	constructor (
		private localAppData: ICommonAppData,
		protected appConfig: ICommonAppConfig,
	) {
		super();
	}

	init (): any {
		const isDevServer = isEmpty(window.AppData);
		const appData: ICommonAppData = isDevServer ? this.localAppData : window.AppData;

		this.setData({
			...omit(environment, [ 'proxy', 'language', 'devspecs']),
			...this.appConfig,
			...appData,
			isDevServer,
		});

		return super.getData();
	}

	getData (): ICommonAppDataServiceData {
		const data = super.getData();

		// если данных нет - будет полная инициализация
		if (isEmpty(data)) {
			return this.init();
		}

		return data;
	}

	getDataByPath (path: string): any {
		// вызов перегруженного метода, чтобы прошла инициализация, если ее не было
		return get(this.getData(), path);
	}
}


export const commonAppDataServiceFactory = (
	localAppDataGetter: TLocalAppDataGetter,
	appConfig: ICommonAppConfig,
): CommonAppDataService => new CommonAppDataService(localAppDataGetter(environment.language, window.location), appConfig);
